import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export interface UserOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-user-options-menu',
  standalone: true,
  imports: [],
  templateUrl: './user-options-menu.component.html',
  styleUrl: './user-options-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserOptionsMenuComponent {
  readonly title = input<string>('');
  readonly options = input<UserOption[]>([]);
  readonly selectedValue = input<string | null>(null);
  readonly optionSelectedEvent = output<string>();

  onSelect(value: string): void {
    this.optionSelectedEvent.emit(value);
  }
}
